/* eslint-disable consistent-return */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable object-shorthand */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable import/order */
import {
  Box,
  Button,
  IconButton,
  InputBase,
  TextField,
  makeStyles,
} from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { parseISO } from 'date-fns'
import React, { useEffect, useState } from 'react'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import { useDispatch, useSelector } from 'react-redux'

import styles from '../../../resources/theme/users'
import { fetchClients, findCep, findClient } from '../ClientActions'
import { fetchKnowWayOptions } from '../../knowWay/KnowWayActions'
import { validate } from './form/validation'
import AddressFields from './address/AddressFields'
import KnowWaySelect from './form/KnowWaySelect'
import DocumentField from './form/DocumentField'
import Icon from '@mdi/react'
import colors from '../../../assets/colors'
import BasePopUp from '../../../components/hooks/BasePopUp'
import NumberFormat from 'react-number-format'
import { parseValue } from '../../../util/utils'
import { useLabel } from '../../../hooks/useLabel'
import format from 'date-fns/format/index.js'
import { mdiChevronDown, mdiChevronUp, mdiMapMarkerOutline } from '@mdi/js'
import CoordinatesSection from './coordinates/CoordinatesSection'
import PhoneField from '../../components/PhoneField'

const useStyles = makeStyles({
  footer: {
    widht: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: '2em',
  },
  submmitButton: {
    minWidth: '99px',
    minHeight: '30px',
    borderRadius: '15px',
    padding: '2px 16px',
    fontWeight: 'normal',
    textTransform: 'capitalize',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    color: '#FFFF',
    backgroundColor: colors.primary,
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: colors.primary,
      opacity: 0.7,
    },
  },
  toggleButton: {
    color: '#FFFF',
    fontSize: '14px',
    fontWeight: 'normal',
    textTransform: 'none',
    backgroundColor: colors.primary,
    borderRadius: '10px',
    padding: '4px 12px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      opacity: 0.7,
      backgroundColor: colors.primary,
    },
  },
})

const Form = ({
  data,
  onSubmit,
  children,
  btnText,
  icon,
  know_way_id,
  notShowPost,
  submitOnBlur = false,
  requiredKnowWay = false,
  onBlurEvent = null,
  onKnowWayChange = null,
  attendance = false,
}) => {
  const dispatch = useDispatch()

  const knowWays = useSelector(state => state.knowWay.options)
  const [openClientModal, setOpenClientModal] = useState(false)

  const [showLocation, setShowLocation] = useState(false)

  const [client, setClient] = useState({})

  const handleOpenClientModal = () => {
    setOpenClientModal(!openClientModal)
  }

  const [errors, setErrors] = useState({})

  const classes = useStyles()
  const label = useLabel()

  const [form, updateForm] = useState({
    id: '',
    name: '',
    person_type: '',
    birthday: null,
    cep: '',
    street: '',
    complement: '',
    number: '',
    city: '',
    uf: '',
    neighborhood: '',
    phone: '',
    phone2: '',
    email: '',
    cpf_cnpj: '',
    client_since: null,
    know_way_id: '',
    profile: '',
    commission_percent: null,
    coordinates: {
      lat: '',
      lng: '',
    },
  })

  // O erro de um campo some assim que ele é editado
  const clearError = name => {
    if (errors[name]) setErrors({ ...errors, [name]: '' })
  }

  const updateField = React.useCallback(name => e => {
    clearError(name)

    // O PhoneField entrega o valor mascarado; o telefone grava só os dígitos
    if (name === 'phone' || name === 'phone2') {
      return updateForm({
        ...form,
        [name]: e.target.value.replace(/[^\d]/g, ''),
      })
    }

    if (name === 'commission_percent') {
      return updateForm({
        ...form,
        [name]: parseValue(e.target.value),
      })
    }

    updateForm({
      ...form,
      [name]: e.target.value,
    })
  })

  const updateFields = React.useCallback(
    (name, value) => {
      updateForm({
        ...form,
        [name]: value,
      })
    },
    [form]
  )

  const onSubmitForm = (advanceTab = false, dataForm = form) => {
    if (submitOnBlur) {
      if (!advanceTab) return onBlurEvent && onBlurEvent('', '', dataForm)

      onSubmit && onSubmit(dataForm, false, null)
    } else {
      onSubmit && onSubmit(dataForm)
    }
  }

  const handleBlur = () => {
    if (submitOnBlur) onSubmitForm(false)
  }

  // Merge de campos alterados por um subcomponente (endereço, coordenadas)
  const handleFieldsChange = partial => {
    updateForm({ ...form, ...partial })
  }

  // Na OS envia já com o endereço encontrado, sem esperar o setState
  const handleLookup = partial => {
    const data = { ...form, ...partial }

    if (submitOnBlur) return onSubmitForm(false, data)

    updateForm(data)
  }

  // Parseia apenas a parte da data (yyyy-MM-dd) para evitar que o offset
  // de fuso horário do ISO em UTC desloque o aniversário para o dia anterior
  const parseDateOnly = date => {
    if (!date) return null
    return parseISO(String(date).substring(0, 10))
  }

  useEffect(() => {
    updateForm({
      ...form,
      ...data,
      know_way_id: data?.know_way_id || know_way_id,
      birthday: parseDateOnly(data?.birthday),
    })

    if (data?.coordinates?.lat && data?.coordinates?.lng) setShowLocation(true)
  }, [data])

  useEffect(() => {
    if (knowWays?.length > 0) return
    dispatch(fetchKnowWayOptions())
  }, [])

  const handleSubmmit = () => {
    const newErrors = validate(form, { requiredKnowWay, notShowPost })
    setErrors(newErrors)

    if (Object.keys(newErrors).length) return

    onSubmitForm(true)
  }

  const handleVerifyPhone = async value => {
    if (!value) {
      return
    }

    if (value == '00000000000') return

    const resp = await findClient({ phone: value })

    if (resp && resp[0]) {
      setClient(resp[0])
      handleOpenClientModal()
    }
  }

  const handleAcceptClient = () => {
    handleOpenClientModal()
    setErrors({})
    updateForm({
      ...form,
      ...client,
    })
  }

  return (
    <ValidatorForm /* onSubmit={onSubmitForm} */>
      <Grid container spacing={2} style={{ marginTop: '1em' }}>
        <Grid item sm={6} xs={12} lg={4}>
          <TextField
            required
            onChange={updateField('name')}
            error={!!errors.name}
            helperText={errors.name || ''}
            label={label('name', 'Nome')}
            fullWidth
            value={form.name}
            onBlur={handleBlur}
          />
        </Grid>
        <Grid item sm={6} xs={12} lg={4}>
          <PhoneField
            label={label('phone_1', 'Telefone 1')}
            required
            fullWidth
            value={form.phone}
            name="phone"
            onChange={updateField('phone')}
            onVerify={handleVerifyPhone}
            onBlur={handleBlur}
            error={!!errors.phone}
            helperText={errors.phone || ''}
          />
        </Grid>
        <Grid item sm={6} xs={12} lg={4} justifyContent="center">
          {attendance ? (
            // Na OS o "como soube" é da OS, não do cliente: valor e gravação vêm de fora
            <KnowWaySelect
              value={know_way_id}
              onChange={onKnowWayChange}
              required
            />
          ) : (
            <KnowWaySelect
              value={form.know_way_id}
              onChange={value =>
                updateField('know_way_id')({ target: { value } })
              }
              required={requiredKnowWay}
              error={!!errors.know_way_id}
              helperText={errors.know_way_id || ''}
            />
          )}
        </Grid>

        <AddressFields
          value={form}
          onChange={handleFieldsChange}
          onBlur={handleBlur}
          onLookup={handleLookup}
        />

        <Grid item sm={6} xs={12} lg={3}>
          <TextValidator
            validators={['isEmail']}
            errorMessages={['O campo não representa um email válido']}
            onChange={updateField('email')}
            label={label('email', 'E-mail')}
            fullWidth
            value={form.email}
            onBlur={handleBlur}
          />
        </Grid>
        <Grid item sm={6} xs={12} lg={notShowPost ? 4 : 2}>
          <PhoneField
            label={label('phone_2', 'Telefone 2')}
            validate
            fullWidth
            value={form.phone2}
            name="phone2"
            onChange={updateField('phone2')}
            onBlur={handleBlur}
          />
        </Grid>
        <Grid item sm={6} xs={12} lg={3}>
          <DocumentField
            value={form.cpf_cnpj}
            onChange={updateField('cpf_cnpj')}
            onBlur={handleBlur}
          />
        </Grid>
        <Grid item sm={6} xs={12} lg={2}>
          <KeyboardDatePicker
            clearable
            value={form.birthday}
            label={label('birthday', 'Aniversário')}
            fullWidth
            views={['date', 'month']}
            clearLabel="Limpar"
            invalidDateMessage="Data inválida"
            autoOk
            onChange={date => updateForm({ ...form, birthday: date })}
            format="dd/MM"
            onBlur={handleBlur}
            KeyboardButtonProps={{
              'aria-label': 'mudar data',
            }}
          />
        </Grid>
        {!notShowPost && (
          <Grid item sm={6} xs={12} lg={2} justifyContent="center">
            <NumberFormat
              value={form.commission_percent}
              onChange={updateField('commission_percent')}
              endAdornment="%"
              decimalScale={2}
              label={label('commission_percent', 'Comissão (%)')}
              decimalSeparator=","
              thousandSeparator="."
              customInput={TextField}
              displayType="input"
              InputProps={{
                endAdornment: '%',
              }}
              fullWidth
              error={!!errors.commission_percent}
              helperText={errors.commission_percent || ''}
            />
          </Grid>
        )}

        <Grid item xs={12} style={{ marginTop: '.5em' }}>
          <TextField
            placeholder={label('client_profile', 'Perfil do cliente')}
            value={form.profile}
            onChange={updateField('profile')}
            multiline
            maxRows={10}
            minRows={5}
            fullWidth
            onBlur={handleBlur}
          />
        </Grid>

        {children}
      </Grid>

      <Box className={classes.footer}>
        <Box style={{ flex: 1 }}>
          <Button
            className={classes.toggleButton}
            onClick={() => setShowLocation(!showLocation)}
            startIcon={<Icon path={mdiMapMarkerOutline} size={0.8} />}
            endIcon={
              <Icon
                path={showLocation ? mdiChevronUp : mdiChevronDown}
                size={0.8}
              />
            }
          >
            Link de Coordenada
          </Button>
        </Box>

        <IconButton onClick={handleSubmmit} className={classes.submmitButton}>
          {btnText}
          {icon && <Icon path={icon} size={1} />}
        </IconButton>
      </Box>

      {showLocation && (
        <CoordinatesSection value={form} onChange={handleFieldsChange} />
      )}

      <BasePopUp
        open={openClientModal}
        type="info"
        title="Cliente já cadastrado"
        message="Este telefone já está cadastrado, deseja recuperar os dados?"
        handleOpen={handleOpenClientModal}
        onConfirm={handleAcceptClient}
      />
    </ValidatorForm>
  )
}

export default withStyles(styles)(Form)
